import PropTypes from 'prop-types';
import React from 'react';

// The line icons of the partner panel, drawn as in its design. They are
// decoration: the control that holds one carries the text or the label.
const LineIcon = ({ size, strokeWidth, children }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

LineIcon.propTypes = {
  size: PropTypes.number.isRequired,
  strokeWidth: PropTypes.number,
  children: PropTypes.node.isRequired,
};

LineIcon.defaultProps = {
  strokeWidth: 2,
};

export const SearchIcon = () => (
  <LineIcon size={18}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </LineIcon>
);

export const OverviewIcon = () => (
  <LineIcon size={20}>
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </LineIcon>
);

export const WhatsappIcon = () => (
  <LineIcon size={16} strokeWidth={2.2}>
    <path d="M21 11.5a8.5 8.5 0 0 1-12.6 7.4L3 20.5l1.6-5.2A8.5 8.5 0 1 1 21 11.5z" />
  </LineIcon>
);

export const NewTabIcon = () => (
  <LineIcon size={16}>
    <path d="M15 3h6v6M10 14 21 3M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
  </LineIcon>
);

export const LogoutIcon = () => (
  <LineIcon size={20} strokeWidth={2.2}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <path d="m16 17 5-5-5-5" />
    <path d="M21 12H9" />
  </LineIcon>
);
